import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router";
import axios from "axios";
import {Provider} from "react-redux";
import store from "@/store.ts"
import * as Sentry from "@sentry/react";
import {AuthProvider, AuthProviderProps} from "react-oidc-context";
import {WebStorageStateStore} from "oidc-client-ts";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

export const keycloakApi = axios.create({
    baseURL: `${import.meta.env.VITE_KEYCLOAK_URL}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/`,
    withCredentials: true,
    withXSRFToken: false,
})

export const keycloakAdminApi = axios.create({
    baseURL: `${import.meta.env.VITE_KEYCLOAK_URL}/admin/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/`,
    withCredentials: true,
    withXSRFToken: false,
})

Sentry.init({
    dsn: "https://9c22a625b980b81779bdc49973241804@sentry.tutgroup.hu/2",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            networkDetailAllowUrls: ['*']
        }),
    ],
    environment: import.meta.env.MODE,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost",  /localhost:5173/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const oidcConfig: AuthProviderProps = {
    authority: `${import.meta.env.VITE_KEYCLOAK_URL}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}`,
    client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    redirect_uri: `${window.location.origin}${window.location.pathname}`,
    userStore: new WebStorageStateStore({store: window.localStorage}),
    onSigninCallback: (): void => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        )
    },
}


const router = createBrowserRouter(createRoutesFromElements(<Route path='*' element={<App/>}/>));
createRoot(document.getElementById('root')!).render(
    <AuthProvider {...oidcConfig}>
        <StrictMode>
            <Provider store={store}>
                <RouterProvider router={router}/>
            </Provider>
        </StrictMode>
    </AuthProvider>
)
